import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { setStyle } from '../helpers/dom'

const getBrowserScrollbarWidth = () => {
  const windowInnerWidth = window.innerWidth

  const documentClientWidth = document.documentElement.clientWidth

  const scrollbarWidth = windowInnerWidth - documentClientWidth

  return scrollbarWidth
}

const disableBodyScrollEl = (targetElement, allowTouchMove = false, reverseScrollBarGapWrapId = null) => {
  if (reverseScrollBarGapWrapId) {
    const scrollbarWidth = getBrowserScrollbarWidth()
    const wrapEl = document.getElementById(reverseScrollBarGapWrapId)

    if (wrapEl) {
      setStyle('padding-right', `${scrollbarWidth}px`, wrapEl)
      setStyle('margin-right', `-${scrollbarWidth}px`, wrapEl)
    }
  }

  disableBodyScroll(targetElement)
}

const clearAllBodyScroll = (reverseScrollBarGapWrapId = null) => {
  if (reverseScrollBarGapWrapId) {
    const wrapEl = document.getElementById(reverseScrollBarGapWrapId)

    if (wrapEl) {
      setStyle('padding-right', '', wrapEl)
      setStyle('margin-right', '', wrapEl)
    }
  }

  clearAllBodyScrollLocks()
}

export {
  disableBodyScrollEl,
  clearAllBodyScroll
}
